import CachedIcon from '@mui/icons-material/Cached';
import EditIcon from '@mui/icons-material/Edit';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import { Card, CardContent, CardHeader, CircularProgress, IconButton, Typography } from "@mui/material";
import * as React from "react";
import { connect } from "react-redux";
import { ConfirmTimeModel } from "../../../models";
import { actionCreators, ApplicationState, FetchState, selectors } from "../../../store";
import FetchHelper from '../../FetchHelper';
import { disabledRefreshAllBtnStyle, disabledRefreshSuccessIconStyles, enableRefreshAllBtnStyle, enableRefreshSuccessIconStyles, pollingColStyle, pollingColStyleTitle } from '../../styles';
import ConfirmTimeDialog from '../pollingTopicDetails_JSPDevice/ConfirmTimeDialog';

const NO_OF_POLLING_TOPIC = 7;
const params = {
    mainid: "",
    isRefreshAllBegin: 0,
    loadingRefreshAll: [false],
    isRefreshGroup: false,
    isDisbleRefeshBtn: true,
    isDisbleUpdateBtn: true,
    isEdit: false,
    centralId: "",
    deviceNo: "",
    isRefreshAllCompleted: (status: number) => { },
    setDisabledRefreshGroupBtn: (disabled: boolean, name: string) => { },
    setRefreshGroup: (refreshGroup: boolean, name: string) => { },
    setIsEdit: (isEdit: boolean) => { },
}

type ConfirmTimeProps = {
    defaultData: ConfirmTimeModel | undefined;
    isRefreshSuccessDeviceNo?: boolean;
    onRefreshComplete?: () => void;
};

export type PureConfirmTimeProps = ConfirmTimeProps & ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps & typeof params;

const fetchId = "CONFIRM_TIME_FETCH";
const updateConfirmTimeFetchId = "UPDATE_CONFIRM_TIME_FETCH_ID";
export const ConfirmTime_TJ360VersionDevice = (props: PureConfirmTimeProps) => {
    const { defaultData, fetchState, mainid, isRefreshAllBegin, loadingRefreshAll, isRefreshGroup, isDisbleRefeshBtn, isDisbleUpdateBtn, isEdit, centralId, deviceNo, isRefreshSuccessDeviceNo } = props;
    const { onUpdateError, onUpdateSuccess, onError, onRefresh, isRefreshAllCompleted, setDisabledRefreshGroupBtn, setRefreshGroup, onUpdate, setIsEdit } = props;
    const [confirmTime, setConfirmTime] = React.useState<ConfirmTimeModel|null>(props.fetchState.data);
    const [refreshFlg, setRefreshFlg] = React.useState(false);
    const [isRefreshSuccess, setIsRefreshSuccess] = React.useState(false);
    const [editFlg, setEditFlg] = React.useState<boolean>(false);
    const [openDialog,setOpenDialog] = React.useState<boolean>(false);
    const [updateLoading, setUpdateLoading] = React.useState(false);
    const [updateData, setUpdateData] = React.useState<any>();

    React.useEffect(() => {
        if(!isRefreshSuccessDeviceNo)
            setIsRefreshSuccess(false);
    }, [isRefreshSuccessDeviceNo]);
    
    // パラメータ設定
    const handleFetchParams = () => {
        const params = new Map<string, any>();
        const code = "PO";
        params.set("code", code);
        params.set("mainid", mainid);
        params.set("centralid", centralId);
        params.set("device_no", deviceNo);
        return params;
    }

    // デマンド現在値取得成功時
    const handleFetchSuccess = (data: any, action: string, isClickedRefreshBtn: boolean) => {
        setUpdateLoading(false);
        setEditFlg(false);
        const resData = {
            mainid: data.mainid,
            year: data.year,
            month: data.month,
            day: data.day,
            hour: data.hour,
            minute: data.minute,
            lastGetDatetime: data.last_get_datetime,
        } as ConfirmTimeModel;
        setConfirmTime(resData);
        action === "edit" && setOpenDialog(true);
        loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false;
        setRefreshGroup(false, fetchId);
        isClickedRefreshBtn && setIsRefreshSuccess(true);
    };

    const handleError = (success: boolean, data: any, error: any) => {
        setEditFlg(false);
        onError(success, data, error);
        if (isRefreshAllBegin > 0) {
            isRefreshAllCompleted(isRefreshAllBegin + 1);
        }
        loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] = false;
        setRefreshGroup(false, fetchId);
        setIsRefreshSuccess(false);
    }

    const handleRefresh = () => {
        setIsRefreshSuccess(false);
        const params = handleFetchParams();
        onRefresh(params);
    };

    const handleRefreshSuccess = (data: any, fetchId: string) => {
        editFlg ? handleFetchSuccess(data, 'edit', true) : handleFetchSuccess(data, 'view', true);
        if (isRefreshAllBegin !== 0) {
            isRefreshAllCompleted(isRefreshAllBegin + 1);
        }
        props.onRefreshComplete?.();
    }

    const refreshAll = () => {
        if (isRefreshAllBegin === NO_OF_POLLING_TOPIC) {
            console.log("fetch No:______" + isRefreshAllBegin);
            handleRefresh();
        }
        if (isRefreshGroup) {
            handleRefresh();
            setIsRefreshSuccess(false);
        }
        if (loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) {
            setIsRefreshSuccess(false);
        }
        isRefreshAllBegin > 0 || isRefreshGroup ? setRefreshFlg(true) : setRefreshFlg(false);
    }
    

    // React.useEffect(() => {
    //         setIsEdit(editFlg);
    //         // eslint-disable-next-line
    //     }, [editFlg]);

    const handleEdit = () => {
        setEditFlg(true);
        const params = handleFetchParams();
        onRefresh(params);
        setIsRefreshSuccess(false);
    };

    const handleEditOk = (request:any) => {
        setOpenDialog(false);
        setUpdateLoading(true);
        const requestData = {
            device_no: deviceNo,
            centralid: centralId,
            mainid: request.mainid,
            year: request.year,
            month: request.month,
            day: request.day,
            hour: request.hour,
            minute: request.minute,
        }
        onUpdate(requestData);
        setUpdateData(request);
        setIsRefreshSuccess(false);
    }

    const handleUpdateSuccess = (success:any, data:any, error:any) => {
        const result = {
            mainid: data.mainid,
            resultCode: data.result_code,
            last_get_datetime: data.last_get_datetime,
        };
        if (result.resultCode === '0') {
            onUpdateSuccess();
            handleFetchSuccess({...updateData, last_get_datetime: data.last_get_datetime}, 'view', true);
        } else {
            handleUpdateError(success, data, error);
        }
    }

    const handleUpdateError = (success: boolean, data: any, error: any) => {
        onUpdateError(success, data, error);
        setUpdateLoading(false);
        setEditFlg(false);
        setIsRefreshSuccess(true);
    }

    // eslint-disable-next-line
    React.useEffect(refreshAll, [isRefreshAllBegin, isRefreshGroup]);

    React.useEffect(() => {
        setIsEdit(editFlg);
        // eslint-disable-next-line
    }, [editFlg]);

    React.useEffect(() => {
        setDisabledRefreshGroupBtn(fetchState.loading || updateLoading, fetchId);
        // eslint-disable-next-line
    }, [updateLoading, fetchState.loading]);

    React.useEffect(() => {
        defaultData && handleFetchSuccess(defaultData, 'view', false);
        if(!defaultData) {
            setConfirmTime(null);
        }
        // eslint-disable-next-line
    }, [defaultData]);

    return (
        <>
            <Card style={{ margin: '0 auto 12px', backgroundColor: '#f5faff', width: '100%' }}>
                <CardHeader
                    avatar={
                        <PublishedWithChangesIcon style={isRefreshSuccess ? enableRefreshSuccessIconStyles : disabledRefreshSuccessIconStyles} />
                    }
                    action={
                        <div>
                            <IconButton aria-label="edit" onClick={handleEdit} disabled={isDisbleUpdateBtn || isEdit || fetchState.loading || refreshFlg || updateLoading}>
                                <EditIcon fontSize="medium" style={isDisbleUpdateBtn || isEdit === true || refreshFlg || updateLoading || fetchState.loading ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                            <IconButton aria-label="refresh" onClick={handleRefresh} disabled={isDisbleRefeshBtn || refreshFlg || updateLoading || editFlg || fetchState.loading}>
                                <CachedIcon fontSize="medium" style={isDisbleRefeshBtn || refreshFlg || updateLoading || editFlg || fetchState.loading ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                            </IconButton>
                        </div>
                    }
                    title='時間確認'
                    titleTypographyProps={{ variant: 'h5' }}
                />
                <CardContent style={{ padding: '0 0 16px 0' }}>
                    {(fetchState.loading || loadingRefreshAll[NO_OF_POLLING_TOPIC - 1] === true) || updateLoading ? (
                        <div style={{ display: 'flex', position: 'relative' }}>
                            <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                                <tbody>
                                    <tr>
                                        <td style={pollingColStyleTitle}>年</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>月</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>日</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>時</td>
                                    </tr>
                                    <tr>
                                        <td style={pollingColStyleTitle}>分</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div style={{ position: 'absolute', top: '40%', left: '60%' }}>
                                <CircularProgress style={{ margin: 'auto' }} />
                            </div>
                        </div>
                    ) : (
                        <table className='polling' style={{ borderCollapse: 'collapse', width: '100%', margin: 'auto' }}>
                            <tbody>
                                <tr>
                                    <td style={pollingColStyleTitle}>年</td>
                                    <td style={pollingColStyle}>{confirmTime?.year}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>月</td>
                                    <td style={pollingColStyle}>{confirmTime?.month}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>日</td>
                                    <td style={pollingColStyle}>{confirmTime?.day}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>時</td>
                                    <td style={pollingColStyle}>{confirmTime?.hour}</td>
                                </tr>
                                <tr>
                                    <td style={pollingColStyleTitle}>分</td>
                                    <td style={pollingColStyle}>{confirmTime?.minute}</td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    <Typography display='flex' justifyContent='flex-end' padding='4px 4px 0 0'>最終取得日時：{confirmTime?.lastGetDatetime ?? '-'}</Typography>
                </CardContent>
            </Card >

            {
                openDialog ? (
                    <>
                        <ConfirmTimeDialog
                            onOK={(data) => {
                                handleEditOk(data);                            
                            }}
                            onCancel={() => {
                                setOpenDialog(false);
                            }}
                            initialValue={confirmTime}
                        />
                    </>
                ) : (
                    <div />
                )
            }
            <FetchHelper fetchId={fetchId} onComplete={(success, data, error) => success ? handleRefreshSuccess(data, fetchId) : handleError(success, data, error)} />
            <FetchHelper fetchId={updateConfirmTimeFetchId} onComplete={(success, data, error) => success ? handleUpdateSuccess(success, data, error) : handleUpdateError(success, data, error)} />
        </>
    );
};
const mapStateToProps = (state: ApplicationState) => ({
    fetchState: selectors.getFetchState(
        state,
        fetchId
    ) as FetchState,
});
const mapDispatchToProps = {
    onRefresh: (params: any) => actionCreators.fetch(fetchId, `/polling-nrf/get`, "GET", params),
    onUpdate: (data: any) => actionCreators.fetch(updateConfirmTimeFetchId, `/polling-nrf/set?code=PP`, 'POST', data, false, true),
    onError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: "時間確認取得",
            body: "時間確認取得できませんでした。",
        }),
    onUpdateSuccess: () =>
        actionCreators.showMessage({
            type: "info",
            title: "時間確認変更",
            body: "時間確認を更新しました。",
        }),
    onUpdateError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: "時間確認変更",
            body: "時間確認を変更できませんでした。",
        }),
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ConfirmTime_TJ360VersionDevice);


